import React, { Component, Fragment } from 'react';

import './CronogramaCal.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Link } from 'react-router-dom';
import { FaArrowCircleLeft, FaFilePdf, FaSearch } from 'react-icons/fa';

import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Grid,
  TextField,
  Button,
  InputAdornment
} from '@mui/material';
import {
  DataGrid,
  esES,
  GridToolbarQuickFilter
} from '@mui/x-data-grid';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { getListaCal, getListaCalFiltrado } from '../../../redux/actions/dataactions';





export class CronogramaCal extends Component {
  constructor() {
    super();
    this.state = {
      fechaInicio: '',
      fechaFin: '',
      searchQuery: '',
      errors: {}
    };
  }

  componentDidMount() {
    this.props.getListaCalFiltrado(this.props.user.credentials.idprestador, "01/01/1950", "01/01/2035", "Todos");
  }

  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value || '' });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleResetFiltros = () => {
    this.setState({
      fechaInicio: '',
      fechaFin: '',
      searchQuery: '',
      errors: { ...this.state.errors, fechaInicio: null, fechaFin: null }
    });

    this.props.getListaCalFiltrado(
      this.props.user.credentials.idprestador,
      "01/01/1950",
      "01/01/2035",
      "Todos"
    );
  };

  handleFiltrar = () => {
    const { fechaInicio, fechaFin } = this.state;
    const errors = {};
    if (!fechaInicio) errors.fechaInicio = 'Requerido';
    if (!fechaFin) errors.fechaFin = 'Requerido';
    if (Object.keys(errors).length) {
      this.setState({ errors: { ...(this.state.errors || {}), ...errors } });
      return;
    }

    this.props.getListaCalFiltrado(
      this.props.user.credentials.idprestador,
      moment(fechaInicio).format('DD/MM/YYYY'),
      moment(fechaFin).format('DD/MM/YYYY'),
      "Todos"
    );
  };

  filterEquipos = () => {
    const { equiposcal } = this.props.data || {};
    const list = Array.isArray(equiposcal) ? equiposcal : [];
    const q = String(this.state.searchQuery || '').toLowerCase();

    const TEXT_FIELDS = [
      'idinventario', 'nombre', 'marca', 'modelo', 'serie', 'ubicacion', 'servicio', 'estado', 'fecha', 'mesnombre', 'lugar'
    ];

    const filtered = list.filter((item) =>
      TEXT_FIELDS.some((field) => {
        const val = item?.[field];
        return val != null && String(val).toLowerCase().includes(q);
      })
    );

    const toDate = (s) => {
      const m = moment(s, ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY'], true);
      return m.isValid() ? m.toDate() : new Date(s);
    };
    return filtered.sort((a, b) => toDate(b.fecha) - toDate(a.fecha));
  };

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI?.errors) newState.errors = props.UI.errors;
    if (props.UI?.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length > 0 ? newState : null;
  }

  render() {
    const { equiposcal, loadingcal } = this.props.data;
    const { errors } = this.state;

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <Tooltip title="Ver Perfil">
            <IconButton
              size="small"
              component={Link}
              to={`/dashboard/inventarioequiposasistencial/hojadevidaequipo/${params.row.equipoid}/${params.row.clienteid}`}
            >
              <ChevronRightIcon />
            </IconButton>
          </Tooltip>
        )
      },
      { field: 'idinventario', headerName: 'Id', width: 110 },
      { field: 'nombre', headerName: 'Nombre', width: 150 },
      { field: 'serie', headerName: 'Serie', width: 130 },
      { field: 'modelo', headerName: 'Modelo', width: 130 },
      { field: 'ubicacion', headerName: 'Ubicación', width: 150 },
      { field: 'fecha', headerName: 'Fecha', width: 120 },
      { field: 'estado', headerName: 'Estado', width: 120 },
      { field: 'lugar', headerName: 'Lugar', width: 150 }
    ];

    const filteredRows = this.filterEquipos();
    const rows = filteredRows.map((row, index) => ({ id: row.idinventario || index, ...row }));

    const mapeoequipos = !loadingcal ? (
      <div>
        <div className='div-container-links-inventario'>
          <Fragment>
            <Link
              className='div-card-link'
              to={{
                pathname: `/dashboard/cronogramacalasistencial/${this.props.user.credentials.idprestador}`,
                state: { filteredEquipos: filteredRows }
              }}
            >
              <div className="dashing-cardcontent">
                <div className="dashing-cardtext">
                  <p className="dashing-text-card">Ver Cronograma en PDF</p>
                </div>
                <div className="dashing-cardicon-green">
                  <FaFilePdf color="#FFFFFF" className="dashing-icon" />
                </div>
              </div>
            </Link>
          </Fragment>
        </div>

        {/* Filtros (con botones custom y lupa en búsqueda) */}
        <Box sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              sx={{ mb: 2 }}
              fullWidth
              size="small"
              label="Buscar programación"
              variant="outlined"
              value={this.state.searchQuery}
              onChange={this.handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FaSearch style={{ opacity: 0.6 }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                fullWidth
                size="small"
                required
                type="date"
                name="fechaInicio"
                id="fechaInicio"
                label="Desde"
                value={this.state.fechaInicio}
                onChange={this.handleChange}
                helperText={errors.fechaInicio}
                error={Boolean(errors.fechaInicio)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <TextField
                fullWidth
                size="small"
                required
                type="date"
                name="fechaFin"
                id="fechaFin"
                label="Hasta"
                value={this.state.fechaFin}
                onChange={this.handleChange}
                helperText={errors.fechaFin}
                error={Boolean(errors.fechaFin)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={this.handleFiltrar}
                size="medium"
                sx={{ height: '40px' }}
              >
                Filtrar
              </Button>
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                onClick={this.handleResetFiltros}
                size="medium"
                sx={{ height: '40px' }}
              >
                Restablecer
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            height: 500,
            width: '100%',
            mt: 2,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'primary.main',
              color: 'white'
            }
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            disableRowSelectionOnClick
          />
        </Box>
      </div>
    ) : (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );

    return (
      <div className='inventario-container'>
        <div className="titulomarket_section">
          <div className="titulo_market">
            <h1 className="text-clientes">Cronograma Calibración</h1>
            <hr className="clientes_separator"></hr>
          </div>

          <div className="divmarket_boton">
            <Link to={`/dashboard/equiposasistencial`} style={{ textDecoration: 'none' }}>
              <Tooltip title="Volver">
                <IconButton size="small">
                  <FaArrowCircleLeft color="#03178C" size={20} />
                </IconButton>
              </Tooltip>
            </Link>
          </div>
        </div>
        {mapeoequipos}
      </div>
    );
  }
}

CronogramaCal.propTypes = {
  getListaCal: PropTypes.func.isRequired,
  getListaCalFiltrado: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
  UI: state.UI
});

const mapDispatchToProps = {
  getListaCal,
  getListaCalFiltrado
};

export default connect(mapStateToProps, mapDispatchToProps)(CronogramaCal);